<mat-card class="control">
    <mat-card-header>
        <h2>Unauthorized</h2>
    </mat-card-header>
    <mat-card-content>
        <p>You have no rights to access this.</p>
    </mat-card-content>
</mat-card>